import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var UmbrellaIcon = function UmbrellaIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_1505_16468)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M16.6663 17.5H3.33301",
        stroke: "#492983",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M12.4211 3.05507C15.6552 4.42757 17.3611 7.99424 16.3994 11.3734L16.3369 11.5942C16.0636 12.5567 15.0086 13.0609 14.0877 12.6701L4.34774 8.53507C3.42691 8.14424 3.05691 7.03507 3.55941 6.16924L3.67441 5.97007C5.43774 2.93257 9.18774 1.68174 12.4211 3.05507Z",
        stroke: "#492983",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M12.4202 3.05469L12.636 3.92719C13.2768 6.52302 12.7143 9.26885 11.1035 11.403",
        stroke: "#492983",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M12.4209 3.05469L11.6434 3.50552C9.33091 4.84719 7.74674 7.16052 7.33008 9.80136",
        stroke: "#492983",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M9.21602 10.5996L6.29102 17.4996",
        stroke: "#492983",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_1505_16468",
        children: /*#__PURE__*/_jsx("rect", {
          width: "20",
          height: "20",
          fill: "white"
        })
      })
    })]
  });
};